import { Typography } from '@material-ui/core';
import React, { Fragment } from 'react';

export const ScheduleDayHeaderView = ({ date, hideDate }: { date: any; hideDate?: any }) => (
  <Fragment>
    <Typography variant="subtitle2" align="center">
      {date.format('ddd')}
    </Typography>
    {!hideDate && (
      <Typography variant="subtitle2" align="center">
        {date.format('D MMM')}
      </Typography>
    )}
  </Fragment>
);
